<template>
    <el-dialog
            title="角色添加/编辑"
            :visible.sync="dialogVisible"
            width="1000px"
            heigth="auto"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" :model="form">
            <el-row :gutter="20" class="mb20">
                <el-col :span="3">
                    <label>角色ID</label>
                </el-col>
                <el-col :span="9">
                    <div class="dec-bc-style">
                        <label>{{userId}}</label>
                    </div>
                </el-col>
                <el-col :span="3">
                    <label>账号统计</label>
                </el-col>
                <el-col :span="9">
                    <div class="dec-bc-style">
                        <label>{{count}}</label>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mb20">
                <el-col :span="3">
                    <label>角色名</label>
                </el-col>
                <el-col :span="9">
                    <el-input v-model="form.name" placeholder="请输入用户名" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <label>数据权限</label>
                </el-col>
                <el-col :span="9">
                    <el-select v-model="form.dataType" placeholder="请选择角色" clearable>
                        <el-option
                                v-for="item in dataTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mb20">
                <el-col :span="3">
                    <label>菜单权限</label>
                </el-col>
                <el-col :span="21">
                    <div class="menu-box">
                        <el-row :gutter="20">
                            <table class="table_style" rules="all">
                                <tr>
                                    <td rowspan="3" class="manage_td">
                                        <el-checkbox v-model="menu.systemMenuCheck" @change="handleClick('sys')">系统管理</el-checkbox>
                                    </td>
                                    <td class="sub_manage_td">
                                        <el-checkbox v-model="menu.systemChildMenu.accountCheck" @change="handleClick('account')">账号管理</el-checkbox>
                                    </td>
                                    <td class="option_td">
                                        <el-row :gutter="20">
                                            <el-col :span="6">
                                                查看<el-switch v-model="menu.systemChildMenu.accountOption.view" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                新建<el-switch v-model="menu.systemChildMenu.accountOption.create" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                编辑<el-switch v-model="menu.systemChildMenu.accountOption.edit" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                冻结解冻<el-switch v-model="menu.systemChildMenu.accountOption.enable" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                密码重置<el-switch v-model="menu.systemChildMenu.accountOption.passwordReset" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                删除<el-switch v-model="menu.systemChildMenu.accountOption.delete" :disabled="!menu.systemChildMenu.accountCheck"></el-switch>
                                            </el-col>
                                        </el-row>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="sub_manage_td">
                                        <el-checkbox v-model="menu.systemChildMenu.roleCheck" @change="handleClick('role')">角色管理</el-checkbox>
                                    </td>
                                    <td class="option_td">
                                        <el-row :gutter="20">
                                            <el-col :span="6">
                                                查看<el-switch v-model="menu.systemChildMenu.roleoption.view" :disabled="!menu.systemChildMenu.roleCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                新建<el-switch v-model="menu.systemChildMenu.roleoption.create" :disabled="!menu.systemChildMenu.roleCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                编辑<el-switch v-model="menu.systemChildMenu.roleoption.edit" :disabled="!menu.systemChildMenu.roleCheck"></el-switch>
                                            </el-col>
                                            <el-col :span="6">
                                                删除<el-switch v-model="menu.systemChildMenu.roleoption.delete" :disabled="!menu.systemChildMenu.roleCheck"></el-switch>
                                            </el-col>
                                        </el-row>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="sub_manage_td">
                                        <el-checkbox v-model="menu.systemChildMenu.systemLogCheck" @change="handleClick('syslog')">系统日志</el-checkbox>
                                    </td>
                                    <td class="option_td">
                                        <el-row :gutter="20">
                                            <el-col :span="6">
                                                查看<el-switch v-model="menu.systemChildMenu.systemLogOption.view" :disabled="!menu.systemChildMenu.systemLogCheck"></el-switch>
                                            </el-col>
                                        </el-row>
                                    </td>
                                </tr>
                            </table>
                        </el-row>
                        <el-row :gutter="20">
                            <table class="table_style" rules="all">
                                <tr>
                                    <td rowspan="2" class="manage_td">
                                        <el-checkbox v-model="menu.enrollMenuCheck" @change="handleClick('enroll')">报名管理</el-checkbox>
                                    </td>
                                    <td class="sub_manage_td">
                                        <el-checkbox v-model="menu.enrollChildMenu.dataCheck" @change="handleClick('data')">数据管理</el-checkbox>
                                    </td>
                                    <td class="option_td">
                                        <el-col :span="6">
                                            查看<el-switch v-model="menu.enrollChildMenu.dataOption.view" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            新建<el-switch v-model="menu.enrollChildMenu.dataOption.create" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            编辑<el-switch v-model="menu.enrollChildMenu.dataOption.edit" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            下载<el-switch v-model="menu.enrollChildMenu.dataOption.download" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            导出<el-switch v-model="menu.enrollChildMenu.dataOption.fileExport" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            提交<el-switch v-model="menu.enrollChildMenu.dataOption.submit" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            审核<el-switch v-model="menu.enrollChildMenu.dataOption.audit" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                              录取审核<el-switch v-model="menu.enrollChildMenu.dataOption.admit" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                          </el-col>
                                        <el-col :span="6">
                                              注册反馈<el-switch v-model="menu.enrollChildMenu.dataOption.regist" :disabled="!menu.enrollChildMenu.dataCheck"></el-switch>
                                          </el-col>
                                        <el-col :span="6">
                                            删除<el-switch v-model="menu.enrollChildMenu.dataOption.delete"></el-switch>
                                        </el-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="sub_manage_td">
                                        <el-checkbox v-model="menu.enrollChildMenu.formCheck" @change="handleClick('form')">表单管理</el-checkbox>
                                    </td>
                                    <td class="option_td">
                                        <el-col :span="6">
                                            查看<el-switch v-model="menu.enrollChildMenu.formOption.view" :disabled="!menu.enrollChildMenu.formCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            新建<el-switch v-model="menu.enrollChildMenu.formOption.create" :disabled="!menu.enrollChildMenu.formCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            编辑<el-switch v-model="menu.enrollChildMenu.formOption.edit" :disabled="!menu.enrollChildMenu.formCheck"></el-switch>
                                        </el-col>
                                        <el-col :span="6">
                                            删除<el-switch v-model="menu.enrollChildMenu.formOption.delete" :disabled="!menu.enrollChildMenu.formCheck"></el-switch>
                                        </el-col>
                                    </td>
                                </tr>
                            </table>
                        </el-row>
                    </div>
                </el-col>

            </el-row>

        </el-form>
        <div class="flex-middle flex-center">
            <el-button plain @click="resetForm">重置</el-button>
            <el-button plain @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import Utils from "../../../assets/js/Utils";

    export default {
        name: 'AddRoleDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                allowAction: [],
                userId: null,
                count: null,
                form: {
                    id: null,
                    name: null,
                    dataType: null,
                    menuConfig: null,
                    userCount: null,
                },
                menuConfig: [],
                menu: {
                    systemMenuCheck: false,
                    systemChildMenu: {
                        accountCheck: false,
                        accountOption: {
                            view: false,
                            create: false,
                            edit: false,
                            enable: false,
                            passwordReset: false,
                            delete: false
                        },
                        roleCheck: false,
                        roleoption: {
                            view: false,
                            create: false,
                            edit: false,
                            delete: false
                        },
                        systemLogCheck: false,
                        systemLogOption: {
                            view: false,
                        }
                    },
                    enrollMenuCheck: false,
                    enrollChildMenu: {
                        dataCheck: false,
                        dataOption: {
                            view: false,
                            create: false,
                            edit: false,
                            download: false,
                            fileExport: false,
                            submit: false,
                            audit: false,
                            admit:false,
                            regist:false,
                            delete: false,
                        },
                        formCheck: false,
                        formOption: {
                            view: false,
                            create: false,
                            edit: false,
                            delete: false,
                        }
                    }
                },
                dataTypeList: [{label:'全部',value:1},{label:'本账号',value:2}],
            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                    Object.assign(this.$data, this.$options.data())
                } else {
                    this.formatConfig2Meun()
                }
            }
        },
        methods: {

            // 显示弹出层
            setMaskVisible(val, data) {
                this.dialogVisible = val
                this.allowAction = Utils.checkMenuOprate('system.role')
                this.form  = Object.assign({},data)
                this.userId = this.form.id
                this.count = this.form.userCount
            },

            formatConfig2Meun() {
                if(this.form.menuConfig) {
                    this.menuConfig = JSON.parse(this.form.menuConfig)
                    for(let i=0;i<this.menuConfig.length;i++) {
                        let item = this.menuConfig[i]
                        if(item.menuItem.indexOf('system') != -1) {
                            this.menu.systemMenuCheck = true
                        }
                        if(item.menuItem.indexOf('enroll') != -1) {
                            this.menu.enrollMenuCheck = true
                        }
                    }
                    for(let i=0;i<this.menuConfig.length;i++) {
                        let item = this.menuConfig[i]
                        switch (item.menuItem) {
                            case 'system.account':
                                this.menu.systemChildMenu.accountCheck = true
                                this.getOptionStatus(item.allowAction,this.menu.systemChildMenu.accountOption)
                                break;
                            case 'system.role':
                                this.menu.systemChildMenu.roleCheck = true
                                this.getOptionStatus(item.allowAction,this.menu.systemChildMenu.roleoption)
                                break;
                            case 'system.log':
                                this.menu.systemChildMenu.systemLogCheck = true
                                this.getOptionStatus(item.allowAction,this.menu.systemChildMenu.systemLogOption)
                                break;
                            case 'enroll.data':
                                this.menu.enrollChildMenu.dataCheck = true
                                this.getOptionStatus(item.allowAction,this.menu.enrollChildMenu.dataOption)
                                break;
                            case 'enroll.form':
                                this.menu.enrollChildMenu.formCheck = true
                                this.getOptionStatus(item.allowAction,this.menu.enrollChildMenu.formOption)
                                break;
                        }
                    }

                }
            },

            getOptionStatus(list,target) {
                list.forEach(item => {
                    switch (item) {
                        case 'view': target.view = true;break;
                        case 'create': target.create = true;break;
                        case 'edit': target.edit = true;break;
                        case 'delete': target.delete = true;break;
                        case 'enable': target.enable = true;break;
                        case 'password.reset': target.passwordReset = true;break;
                        case 'download': target.download = true;break;
                        case 'export': target.fileExport = true;break;
                        case 'audit': target.audit = true;break;
                        case 'admit': target.admit = true;break;
                        case 'regist': target.regist = true;break;
                        case 'submit': target.submit = true;break;
                    }
                })
            },

            formatMenu2Config() {
                let menuConfig = []
                if(this.menu.systemChildMenu.accountCheck) {
                    let item = {
                        menuItem: 'system.account'
                    }
                    item.allowAction = this.getMeunOption(this.menu.systemChildMenu.accountOption)
                    if(item.allowAction && item.allowAction.length > 0 ) {
                        menuConfig.push(item)
                    }
                }
                if(this.menu.systemChildMenu.roleCheck) {
                    let item = {
                        menuItem: 'system.role'
                    }
                    item.allowAction = this.getMeunOption(this.menu.systemChildMenu.roleoption)
                    if(item.allowAction && item.allowAction.length > 0 ) {
                        menuConfig.push(item)
                    }
                }
                if(this.menu.systemChildMenu.systemLogCheck) {
                    let item = {
                        menuItem: 'system.log'
                    }
                    item.allowAction = this.getMeunOption(this.menu.systemChildMenu.systemLogOption)
                    if(item.allowAction && item.allowAction.length > 0 ) {
                        menuConfig.push(item)
                    }
                }
                if(this.menu.enrollChildMenu.dataCheck) {
                    let item = {
                        menuItem: 'enroll.data'
                    }
                    item.allowAction = this.getMeunOption(this.menu.enrollChildMenu.dataOption)
                    if(item.allowAction && item.allowAction.length > 0 ) {
                        menuConfig.push(item)
                    }
                }
                if(this.menu.enrollChildMenu.formCheck) {
                    let item = {
                        menuItem: 'enroll.form'
                    }
                    item.allowAction = this.getMeunOption(this.menu.enrollChildMenu.formOption)
                    if(item.allowAction && item.allowAction.length > 0 ) {
                        menuConfig.push(item)
                    }
                }
                this.form.menuConfig = JSON.stringify(menuConfig)
            },

            getMeunOption(data) {
                let allowAction = []
                if(!data) {
                    return allowAction
                }
                if(data.view && data.view === true) {
                    allowAction.push('view')
                }
                if(data.create && data.create === true) {
                    allowAction.push('create')
                }
                if(data.edit && data.edit === true) {
                    allowAction.push('edit')
                }
                if(data.delete && data.delete === true) {
                    allowAction.push('delete')
                }
                if(data.enable && data.enable === true) {
                    allowAction.push('enable')
                }
                if(data.passwordReset && data.passwordReset === true) {
                    allowAction.push('password.reset')
                }
                if(data.download && data.download === true) {
                    allowAction.push('download')
                }
                if(data.fileExport && data.fileExport === true) {
                    allowAction.push('export')
                }
                if(data.audit && data.audit === true) {
                    allowAction.push('audit')
                }
                if(data.admit && data.admit === true) {
                    allowAction.push('admit')
                }
                if(data.regist && data.regist === true) {
                    allowAction.push('regist')
                }
                if(data.submit && data.submit === true) {
                    allowAction.push('submit')
                }
                return allowAction
            },

            handleClick(data) {
                switch (data) {
                    case 'sys':
                        this.menu.systemChildMenu.accountCheck = this.menu.systemMenuCheck
                        this.menu.systemChildMenu.roleCheck = this.menu.systemMenuCheck
                        this.menu.systemChildMenu.systemLogCheck = this.menu.systemMenuCheck
                        this.handleClick('account')
                        this.handleClick('role')
                        this.handleClick('syslog')
                        break;
                    case 'enroll':
                        this.menu.enrollChildMenu.dataCheck = this.menu.enrollMenuCheck
                        this.menu.enrollChildMenu.formCheck = this.menu.enrollMenuCheck
                        this.handleClick('data')
                        this.handleClick('form')
                        break;
                    case 'account':
                        this.menu.systemChildMenu.accountOption = Object.assign({},{
                            view: this.menu.systemChildMenu.accountCheck===true?true:false,
                            create: this.menu.systemChildMenu.accountCheck===true?false:false,
                            edit: this.menu.systemChildMenu.accountCheck===true?false:false,
                            enable: this.menu.systemChildMenu.accountCheck===true?false:false,
                            passwordReset: this.menu.systemChildMenu.accountCheck===true?false:false,
                            delete: this.menu.systemChildMenu.accountCheck===true?false:false
                        })
                        break;
                    case 'role':
                        this.menu.systemChildMenu.roleoption = Object.assign({},{
                            view: this.menu.systemChildMenu.roleCheck===true?true:false,
                            create: this.menu.systemChildMenu.roleCheck===true?false:false,
                            edit:  this.menu.systemChildMenu.roleCheck===true?false:false,
                            delete:  this.menu.systemChildMenu.roleCheck===true?false:false,})
                        break;
                    case 'syslog':
                        this.menu.systemChildMenu.systemLogOption = Object.assign({},{view: this.menu.systemChildMenu.systemLogCheck===true?true:false})
                        break;
                    case 'data':
                        this.menu.enrollChildMenu.dataOption = Object.assign({},{
                            view: this.menu.enrollChildMenu.dataCheck===true?true:false,
                            create: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            edit: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            download: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            fileExport: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            audit: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            admit: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            regist: this.menu.enrollChildMenu.dataCheck===true?false:false,
                            delete: this.menu.enrollChildMenu.dataCheck===true?false:false,})
                        break;
                    case 'form':
                        this.menu.enrollChildMenu.formOption = Object.assign({},{
                            view: this.menu.enrollChildMenu.formCheck===true?true:false,
                            create: this.menu.enrollChildMenu.formCheck===true?false:false,
                            edit: this.menu.enrollChildMenu.formCheck===true?false:false,
                            delete: this.menu.enrollChildMenu.formCheck===true?false:false,})
                        break;
                }
            },

            resetForm() {
                this.form = {}
                this.form.id = this.userId
                this.form.userCount = this.count
                this.menu.systemMenuCheck = false
                this.menu.enrollMenuCheck = false
                this.handleClick('sys')
                this.handleClick('enroll')
                this.handleClick('account')
                this.handleClick('role')
                this.handleClick('syslog')
                this.handleClick('data')
                this.handleClick('form')

            },

            submit() {
                this.formatMenu2Config()
                let url = Urls.URL.role_url
                let params = {}
                if(this.userId) {
                    url = url + '/' + this.userId
                }
                params.name = this.form.name
                params.dataType = this.form.dataType
                params.menuConfig = this.form.menuConfig
                axios.post(url,params).then(res => {
                    this.dialogVisible = false
                    this.$emit('fetchData')
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

        }
    }
</script>

<style scoped lang="stylus">

    .el-col-3,.el-col-9 {
        height 40px
        display flex
        align-items center
        .dec-bc-style {
            flex: 1
            background-color: #F5F5F5
            height 100%
            display flex
            align-items center
            >label {
                display inline-block
                margin-left 15px
            }
        }
    }

    .menu-box {
        width 100%
    }

    .table_style{
        width 100%;
        text-align :center;
        border : 1px solid #D9D9D9;
        .manage_td {
            width 20%
        }
        .sub_manage_td {
            width 20%
            height 60px
        }
        .option_td {
            flex 1
            .el-col {
                width 25%
                margin-bottom 5px
                >.el-switch {
                    margin-left 5px
                }
            }
        }

    }

    .mb20 {
        margin-bottom 20px
    }

    /deep/.el-select {
        width 100%
    }
</style>
